<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Besvar fraværsanmodning</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <table>
          <tbody>
          <tr>
            <td><b>{{ request.vUserName }}:</b></td>
            <td>{{ request.vSubjectTitle }},</td>
            <td>{{ request.vStart }} -</td>
            <td>{{ request.vEnd }}</td>
          </tr>
          <tr style="border-top: 1px solid #e2e8f0">
            <td colspan="4" class="italic">{{ request.request_note }}</td>
          </tr>
          </tbody>
        </table>
        <div class="marg-1-top">
          <label class="d-label">Note til besvarelsen</label>
          <textarea v-model="note" class="do-input do-textarea" v-focus></textarea>
        </div>
      </div>
      <div class="d-modal__buttons d-modal__buttons__flex">
        <button class="do-bttn"
                @click="rejectRequest"
                :class="{'do-bttn--loading': isLoadingRejected }">
          Afvis
        </button>
        <button class="do-bttn"
                :class="{'do-bttn--loading': isLoadingApprove }"
                @click="approveRequest">
          Godkend
        </button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal.vue'
import eventbus from '../../eventbus'

export default {
  components: {DModal},
  props: {
    request: {
      default: null
    }
  },
  data () {
    return {
      note: '',
      isLoadingApprove: false,
      isLoadingRejected: false
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
        el.select()
      }
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    }
  },
  methods: {
    approveRequest () {
      this.isLoadingApprove = true
      const schoolId = this.request.school_id
      const id = this.request.id
      const responseNote = this.note
      docendo.approveRequest(schoolId, id, responseNote, success => {
        this.requestDone(success)
      }, failure => {
        this.requestDone()
      })
    },
    rejectRequest () {
      this.isLoadingRejected = true
      const schoolId = this.request.school_id
      const id = this.request.id
      const responseNote = this.note
      docendo.rejectRequest(schoolId, id, responseNote, success => {
        this.requestDone(success)
      }, failure => {
        this.requestDone()
      })
    },
    requestDone (resp) {
      this.isLoadingApprove = false
      this.isLoadingRejected = false
      if (resp.status === 'error') {
        this.showToast(resp.message, false)
      } else {
        this.$emit('close')
      }
      this.$emit('submitted')
    },
    showToast (message, success) {
      eventbus.toast = {text: message, success}
    }
  }
}
</script>

<style scoped>

.d-modal {
  width: 650px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.d-modal__buttons {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
}

.d-modal__buttons__flex > .do-bttn {
  flex: 1;
}

.do-textarea {
  min-height: 100px;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// UserRequestListAnswer.vue?124fc0e2